module.exports = __webpack_public_path__ + "static/media/logo129.520553be.png";